export default function Blog() {
  const blogPosts = [
    {
      category: 'Industry Leader',
      title: 'The Physio Network',
      excerpt: 'A comprehensive resource for physiotherapy professionals and patients, featuring evidence-based articles and clinical insights.',
      image: 'https://readdy.ai/api/search-image?query=modern%20physiotherapy%20clinic%20professional%20healthcare%20setting%20clean%20minimalist%20design%20natural%20lighting%20medical%20equipment%20wellness%20center%20contemporary%20interior&width=800&height=600&seq=physblog001&orientation=landscape',
      link: 'https://www.thephysionetwork.com/',
    },
    {
      category: 'Research & Education',
      title: 'Physiopedia',
      excerpt: 'The world\'s largest open-access physiotherapy encyclopedia with over 7,000 articles on conditions, treatments, and research.',
      image: 'https://readdy.ai/api/search-image?query=medical%20education%20books%20research%20physiotherapy%20knowledge%20library%20professional%20healthcare%20learning%20resources%20clean%20background&width=600&height=800&seq=physblog002&orientation=portrait',
      link: 'https://www.physio-pedia.com/',
    },
    {
      category: 'Clinical Excellence',
      title: 'Sports Physio',
      excerpt: 'Leading blog focused on sports injury management, rehabilitation protocols, and performance optimization for athletes.',
      image: 'https://readdy.ai/api/search-image?query=sports%20physiotherapy%20athletic%20training%20rehabilitation%20exercises%20professional%20sports%20medicine%20clinic%20modern%20equipment%20fitness%20recovery&width=600&height=800&seq=physblog003&orientation=portrait',
      link: 'https://www.thesportsphysio.com/',
    },
    {
      category: 'Pain Science',
      title: 'Pain Science',
      excerpt: 'In-depth articles exploring pain mechanisms, treatment approaches, and debunking common myths in pain management.',
      image: 'https://readdy.ai/api/search-image?query=pain%20management%20therapy%20gentle%20treatment%20physiotherapy%20care%20professional%20healthcare%20setting%20calm%20atmosphere%20therapeutic%20environment&width=600&height=800&seq=physblog004&orientation=portrait',
      link: 'https://www.painscience.com/',
    },
    {
      category: 'Professional Development',
      title: 'Physio Matters',
      excerpt: 'Expert insights on clinical practice, patient care strategies, and the latest developments in physiotherapy.',
      image: 'https://readdy.ai/api/search-image?query=physiotherapy%20professional%20consultation%20patient%20care%20modern%20clinic%20setting%20healthcare%20expertise%20wellness%20treatment%20contemporary%20design&width=600&height=800&seq=physblog005&orientation=portrait',
      link: 'https://www.physiomatters.com/',
    },
  ];

  return (
    <section id="blog" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 mb-4">
            <span className="text-teal-700 font-semibold tracking-wider uppercase text-sm">Industry Resources</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Georgia, serif' }}>
            Top Physiotherapy Blogs
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-8">
          {blogPosts.map((post, index) => (
            index === 0 ? (
              <a key={index} href={post.link} target="_blank" rel="noopener noreferrer" className="lg:col-span-8 group cursor-pointer">
                <div className="relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                  <div className="relative" style={{ height: '500px' }}>
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                    <div className="absolute top-6 left-6">
                      <span className="inline-block px-4 py-2 rounded-full bg-white/90 backdrop-blur-sm text-teal-700 text-sm font-semibold">{post.category}</span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                      <h3 className="text-3xl font-bold mb-3 group-hover:text-teal-200 transition-colors">{post.title}</h3>
                      <p className="text-white/90 text-lg mb-4">{post.excerpt}</p>
                      <div className="inline-flex items-center text-teal-200 font-semibold">
                        Visit Website <i className="ri-external-link-line ml-2"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            ) : (
              <a key={index} href={post.link} target="_blank" rel="noopener noreferrer" className="lg:col-span-4 group cursor-pointer">
                <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 h-full">
                  <div className="relative" style={{ height: '280px' }}>
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-6">
                    <span className="inline-block px-3 py-1 rounded-full bg-teal-700 text-white text-xs font-semibold mb-3">{post.category}</span>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">{post.title}</h3>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">{post.excerpt}</p>
                    <div className="inline-flex items-center text-teal-700 font-semibold text-sm">
                      Visit Website <i className="ri-external-link-line ml-2"></i>
                    </div>
                  </div>
                </div>
              </a>
            )
          ))}
        </div>
      </div>
    </section>
  );
}
